import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { asset } from "./assets";
import { appUrl, HOME_PATH } from "./links";
import { StipplMark } from "./ui";
import styles from "./MadMonkey.module.scss";

const NAV: [string, string][] = [
	["#hostels", "Hostel map"],
	["#trips", "Trips"],
	["#how", "How it works"],
	["#faq", "FAQ"],
];

/**
 * The page's own header and footer. The partner page is a standalone page, as the link-in-bio page is: the
 * site's navigation and footer do not link to it and it does not carry them. Framed on Mad Monkey's own site (`embed`)
 * it carries neither: it sits under that site's own header and footer.
 */
const MadMonkeyLayout = ({ children, embed = false }: { children: ReactNode; embed?: boolean }) => (
	<div className={styles.root} id="stippl-madmonkey">
		{!embed && (
			<header className={styles.nav}>
				<div className={styles.wrap}>
					<Link className={styles.lockup} to={HOME_PATH} aria-label="Stippl × Mad Monkey home">
						<span className={styles.logo}>
							<StipplMark />
							stippl.
						</span>
						<span className={styles.times}>×</span>
						<img className={styles.mmLogo} src={asset("img/mm-logo-dark.png")} alt="Mad Monkey" />
					</Link>
					<nav className={styles.navLinks} aria-label="Main">
						{NAV.map(([hash, label]) => (
							<Link key={hash} to={{ pathname: HOME_PATH, hash }}>
								{label}
							</Link>
						))}
					</nav>
					<a id="mm-nav-app" className={`${styles.btn} ${styles.btnGreen}`} href={appUrl("nav")}>
						Get Stippl
					</a>
				</div>
			</header>
		)}
		<main>{children}</main>
		{!embed && (
			<footer className={styles.footer}>
				<div className={styles.wrap}>
					<span>© 2026 stippl. × Mad Monkey Hostels · Plan it in Stippl, sleep at Mad Monkey</span>
					<span>
						<a href="/privacy">Privacy</a> ·{" "}
						<a href="https://madmonkeyhostels.com" rel="noopener">
							madmonkeyhostels.com
						</a>
					</span>
				</div>
			</footer>
		)}
	</div>
);

export default MadMonkeyLayout;
